import { motion } from "framer-motion";
import { Check } from "lucide-react";

const PLANS = [
  {
    id: "privati",
    name: "Privati",
    tagline: "Preventivo gratuito",
    desc: "Per case, famiglie e condomini che cercano un aiuto affidabile.",
    features: [
      "Pulizie interne ed esterne",
      "Pulizia aree verdi e giardini",
      "Progettazione aree verdi",
      "Trasporti, traslochi e sgomberi",
    ],
    cta: "Richiedi Preventivo",
    highlighted: false,
  },
  {
    id: "aziende",
    name: "Aziende e Villaggi",
    tagline: "Preventivo gratuito",
    desc: "Per attività, villaggi turistici e strutture che vogliono un unico referente.",
    features: [
      "Pulizie interni ed esterni continuative",
      "Manutenzione e pulizia aree verdi",
      "Gestione dipendenti e turnazioni",
      "Contratti personalizzati",
      "Referente dedicato H24",
    ],
    cta: "Richiedi Preventivo",
    highlighted: true,
  },
  {
    id: "enti",
    name: "Enti e Strutture",
    tagline: "Convenzioni dedicate",
    desc: "Per enti pubblici e grandi strutture con esigenze complesse.",
    features: [
      "Progettazione aree verdi",
      "Gestione dipendenti e personale",
      "Convenzioni trasparenti",
      "Squadre e mezzi certificati",
    ],
    cta: "Contattaci",
    highlighted: false,
  },
];

export default function Pricing({ onEarlyAccess }) {
  return (
    <section id="prezzi" data-testid="pricing-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="text-center font-mono text-xs uppercase tracking-[0.25em] text-neon"
        >
          {"// Preventivi su misura"}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mx-auto mt-4 max-w-2xl text-center font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl"
        >
          Una soluzione per <span className="text-pulse">ogni esigenza.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {PLANS.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`pricing-card-${p.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`relative flex flex-col rounded-2xl border p-8 transition-all duration-500 ${
                p.highlighted
                  ? "border-neon bg-white shadow-[0_24px_70px_rgba(53,101,174,0.22)] md:-translate-y-3"
                  : "border-[#D9E4F5] bg-white shadow-[0_8px_32px_rgba(22,52,95,0.08)] hover:border-neon/40"
              }`}
            >
              {p.highlighted && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-neon px-4 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-white">
                  Più Richiesto
                </span>
              )}
              <h3 className="font-display text-lg font-semibold">{p.name}</h3>
              <p className="mt-2 text-sm text-slate-600">{p.desc}</p>
              <p className="mt-6 font-display text-2xl font-bold text-neon">
                {p.tagline}
              </p>
              <ul className="mt-8 flex-1 space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-slate-600">
                    <Check className={`mt-0.5 h-4 w-4 shrink-0 ${p.highlighted ? "text-neon" : "text-slate-400"}`} />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`pricing-cta-${p.id}`}
                onClick={() => onEarlyAccess?.(p.id)}
                className={`mt-10 w-full rounded-full py-3.5 font-display text-xs font-bold uppercase tracking-[0.15em] transition-all duration-300 ${
                  p.highlighted
                    ? "bg-neon text-white hover:shadow-[0_12px_40px_rgba(53,101,174,0.5)]"
                    : "border border-[#C9D8EE] text-[#16345F] hover:border-pulse hover:text-pulse"
                }`}
              >
                {p.cta}
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
